import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=ae5fcc3a&"
import script from "./ProductLinks.vue?vue&type=script&lang=js&"
export * from "./ProductLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports